<template>
  <v-container class="white-wrapper" fluid>
    <div class="screen index_screen">
        <div class="wrapper">
            <!-- <header>
                <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
                <h1>결제</h1>
            </header> -->
            <div class="inner">
                <div class="sub_title_box">
                    <h2 class="sub_title">결제정보를 입력해주세요</h2>
                    <!-- 
                    <a  v-if="this.is_detail"  class="detail" @click="onDetail" ><span>detail</span></a>
                    <a  v-else   class="detail" @click="onDetail" ><span>main</span></a>
                    -->

                </div>
                <div class="content">
                    <form class="detail_form">
                        <p>
                            <label for="date">날짜</label>
                            <input type="date" id="currentDate" v-model="currentDate" class="input_field">
                        </p>
                        <p>
                            <label for="price">금액</label>
                            <input  @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="price" v-model="price" class="input_field" placeholder="원">
                        </p>
                        <!-- <p>
                            <label for="number">갯수</label>
                            <input @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="number" name="number"  v-model="number" class="item-number  input_field" placeholder="개">
                        </p> -->
                        <p v-show="is_detail" >
                            <label for="tc">TC <v-icon v-show="is_detail"  style="margin-right: 0.5rem;float: right;color:black;" @click="addRow" >mdi-plus-box</v-icon>  </label>
                            
                            <div style="display: contents;" v-show="is_detail" >
                              <input @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="number" name="number"  v-model="number" class="item-number  input_field" style="width:20%!important"  placeholder="개">
                              <label for="tc" style="margin-right:10px">개</label>  
                              <input @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="tc" name="tc" v-model="tc" class="item-tc input_field" style="width:50%!important" placeholder="원">
                              <label>원</label>
                            </div>

                            <!-- <td><a @click="removeRow(row)">Remove</a></td> -->
                            <div  v-for="(row, index) in tclists" class="tc-lists" style=" display: contents;">
                              <div class="tc-lists2" > 
                                  <input @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="number1" name="number"   class="item-number  input_field" style="width:20%!important"  placeholder="개">
                                  <label for="tc" style="margin-right:10px">개</label>  
                                  <input @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="tc1" name="tc"  class="item-tc input_field" style="width:50%!important" placeholder="원">
                                  <label>원   <v-icon style="margin-right: 0.5rem;float: right;color:black;" @click="delRow(index)"  >mdi-minus-box</v-icon> </label>
                                  
                            </div>

                            </div>

                        </p>
                        <!-- detail -->
                        <p v-show="is_detail">
                            <label for="waiter">웨이터</label>
                            <input   @keyup="upEvt"  @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="waiter" v-model="waiter" @input="changeIn" class="input_field" placeholder="원">
                        </p>
                        <p v-show="is_detail">
                            <label for="food">음식</label>
                            <input   @keyup="upEvt" @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="food" v-model="food" @input="changeIn" class="input_field" placeholder="원">
                        </p>
                        <p v-show="is_detail">
                            <label for="etc">기타</label>
                            <input   @keyup="upEvt"  @blur="upEvt|jsonData(false)" @change="jsonData(false)" type="text" id="etc" v-model="etc" @input="changeIn" class="input_field" placeholder="원">
                        </p>
                        <!-- detail -->

                        <p>
                            <label for="tax">수수료</label>
                            <input readOnly @keyup="upEvt" @blur="upEvt" type="text" id="tax" v-model="tax" @input="changeIn" class="input_field" placeholder="원">
                        </p>
                        <p>
                            <label for="memo">메모</label>
                            <input id="memo" v-model="memo" class="input_field">
                        </p>
                        <p>
                            <label for="total">총액</label>
                            <input readOnly type="text" id="total" v-model="total" class="input_field">
                        </p>
              
                    </form>
                     
                    <a class="pay_btn" @click="qr()">결제하기</a>                  
                        
                </div>
                <div class="bg">
                    <div class="alert pd20">
                        <h6>결제를 진행하시겠습니까?{{this.payment_id }}</h6>
                        <div v-show="this.is_payed" >
                        <!-- QR생성 -->
                          <v-fade-transition leave-absolute >
                            <vue-q-r-code-component                                                                 
                                    :size="200"
                                    :text="this.jsonDataTxt"
                                    class="qr-code"
                                  />
                          </v-fade-transition>
                        
                        </div>


                        <div class="btn_box">
                            <div class="yes" @click="payed()" >YES</div>
                            <div class="no" @click="remove()">NO</div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>                 
    </div>
    <!-- 
    <template>
        <qrcode-stream @decode="onDecode" class="qr-reader-box" />
    </template>
    -->

  </v-container>
</template>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.1.1/jquery.min.js"></script>
<script> 
import '@/staff/css/style.css'
import '@/staff/css/0908_style.css'



import { copyTimestamp } from 'vuetify/lib/components/VCalendar/util/timestamp';

import VueQRCodeComponent from 'vue-qrcode-component' ;
import VueBarcode from 'vue-barcode' ; 
import $ from 'jquery' ; 
import { QrcodeStream } from 'vue-qrcode-reader' ;  // , QrcodeDropZone, QrcodeCapture 


const rtnNum = (str) =>{
  return str.replace(/[^0-9]/g , "");   
  // return  isNaN ( n  ) ? 0 : n ; 
}
 
export default {
  components: { VueQRCodeComponent, VueBarcode , QrcodeStream  },
  data: () => ({
    tclists:[],
    currentDate : '' , 
    price : 0 , 
    number : 0 , 
    tc : 0 , 
    tax : 0 , 
    // detail 
    waiter: 0 , 
    food: 0 , 
    etc: 0 , 
    // detail 
    memo : '' , 
    total : 0  ,  
    tax_fee : 0.05 , 
    jsonDataTxt :'' ,
    qrCodeData: '' , 
    saved : {} ,  
    payedAmt : 0 , 
    payment_id : null , 
    is_payed :false , 
    is_detail :false , 
    nowTime: new Date().getTime(),
    timer: '',
    show: true,
    duration: 10000,
    selectedCoin: null,
    coinName: 'LSS'    
  }),
  watch :{     
  } , 
  computed: {  
    user() {
      return this.$store.getters.user
    },
    jsonData1() {
       
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    wallet() {
      return this.$store.getters.wallet.filter(
        (i) => i.name !== 'USDT' //&& i.name !== 'ETH'
      )
    }
  },
  methods: {
    addRow(){
      this.tclists.push({ });
      this.jsonData(false)
    },
    delRow(index){      
      console.log(index)
      // this.tclists.remove(row);
      this.tclists.splice(index ,1);

      this.jsonData(false) ;

      // setTimeout(function(this){
      //   this.jsonData(false)
      // } , 1000 ) ;        

    },

    onDetail (){ 
       this.is_detail = !this.is_detail  ;  
       this.waiter =  0 ; 
      this.food =  0 ; 
      this.etc =  0 ; 
      this.tclists = [] ;
      this.jsonData(false)

    } , 
    onDecode (result) {
      this.qrCodeData = result
       console.log( this.qrCodeData  , result )  
    }  , 

    jsonData( chk ) {
     
      
      let Obj = { token : 'LSS'  , total : 0  } ; 
        
      let objNum = $("input.item-number");
      let objTc = $("input.item-tc");
      let aryTc = [] ; 
       
      objNum.each(function(k,v){  
        let count  = Number( this.value.replace(/[^0-9]/g , "") )  ; 
        let tc  = Number( $(".item-tc:nth("+k+")" ).val().replace(/[^0-9]/g , ""))  ; 
        console.log( count ,  tc , count * tc   )
        Obj.total  += count * tc   ; 

         aryTc.push({
          count : count  , 
          tc : tc,  
          price : count * tc 
         })  
         // TC합산 금액 
         
      }); 

      Obj.currentDate = this.currentDate ; 
      Obj.memo = this.memo ; 

      Obj.price = rtnNum( this.price+'' );        
      Obj.total += Number( Obj.price) ; 
      this.price = Obj.price.toLocaleString() ; 
// detail 
      Obj.waiter = rtnNum( this.waiter+'' );       
      Obj.total += Number( Obj.waiter) ; 
      this.waiter = Obj.waiter.toLocaleString() ; 
      
      Obj.food = rtnNum( this.food+'' );       
      Obj.total += Number( Obj.food) ; 
      this.food = Obj.food.toLocaleString() ; 

      Obj.etc = rtnNum( this.etc+'' ); 
      Obj.total += Number( Obj.etc) ;       
      this.etc = Obj.etc.toLocaleString() ; 
      // detail       
      
      Obj.tax  = parseInt( Obj.total * this.tax_fee)  ; 
      Obj.total += Obj.tax; 
      this.tax = Obj.tax.toLocaleString() ;  
      Obj.tc = aryTc ; 

      this.payedAmt =  Obj.total ; 

      this.total = Obj.total.toLocaleString() ;   
      console.log( Obj ) ;  
      
      if( chk == false  ) {
        return false ;
      };

      this.saved = Obj ; 
      if( Obj.total <= 0 ) {
        alert(this.$t('common.paymentAmountAlert')) ; 
        return false ; 
      }
      if( this.payment_id !== null ) {

        this.jsonDataTxt = JSON.stringify({
                            uid: this.user.id,
                            now: this.nowTime,
                            token: this.coinName , 
                            payment_id : this.payment_id
                          })  ;  

      }else { 

        this.$store
          .dispatch('STAFF_ACT', {
              proc : 'pay_staff' , 
              uid: this.user.id,
              now: this.nowTime,
              token: this.coinName , 
              req_payed : Obj 
            })
          .then((response) => {
            // console.log( response )
            if (response.data.payment_id) {          

                this.is_payed = true ; 
                const bg = document.getElementsByClassName('bg')[0]      
                bg.style.display = 'block' ; 

                this.jsonDataTxt = JSON.stringify({
                            uid: this.user.id,
                            now: this.nowTime,
                            token: this.coinName , 
                            payment_id : response.data.payment_id 
                          })  ;   
            } else {  
                alert(this.$t('common.paymentInfoAlert')) ; 
                location.reload() ; 
                return false ; 
            } ;  
          }) ; 


      }


    },
    payed(){
      this.jsonData() ;       
      console.log( 'dd : ' , this.jsonDataTxt  ) ; 
    },
    remove() {
      const bg = document.getElementsByClassName('bg')[0]
      bg.style.display = 'none' ;
      this.is_payed = false ;  
    } , 
    upEvt(e){ 
      this.payment_id = null ;
      let temp = Number( rtnNum( e.target.value) )   ;
      e.target.value = temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 

      // e.target.value  =  parseInt(  temp  ) ; 
      // console.log( temp,   temp.toLocaleString(undefined, {maximumFractionDigits: 0})  )
      // e.target.value = temp.toLocaleString(undefined, {maximumFractionDigits: 0}) ; 

    } ,  
    pressEvt(e){ 
      // console.log( e.target.value  , e )
    } , 

    changeIn(obj) {             
    } ,  
    qr() {
      console.log( "qr : " ,  this.payedAmt  )   

      
      if( !isNaN( this.payedAmt )  &&  this.payedAmt > 0 )  {
        const bg = document.getElementsByClassName('bg')[0]
        bg.style.display = 'block'

      }else { 
        alert( this.$t('common.paymentAvailableAlert')); 
        return false ;
      }
      

    } , 

    refresh() {
      this.nowTime = new Date().getTime()
      this.show = true
      this.coinName = this.selectedCoin.name
    },
    fadeRefresh() {
      this.show = false
      setTimeout(this.refresh, 500)
    },
    clickCoin(item) {
      this.selectedCoin = item
      this.fadeRefresh()
      clearInterval(this.timer)
      this.timer = setInterval(this.fadeRefresh, this.duration)
    }
  },
  created() {
    this.timer = setInterval(this.fadeRefresh, this.duration)
    this.selectedCoin = 'LSS' ; //  this.wallet.filter((i) => i.name === 'CCS')[0]
  }
}
</script> 




<style lang="scss" scoped>
    header {
      // height: 45px;
      // position: relative;
      // display: flex;
      // padding-left: 24px;
      // padding-right: 24px;
      // align-items: center;
       border-bottom:none !important; 
    }
    .white-wrapper {
      padding: 0 !important;
      height: 100% !important;
      overflow: auto;
      background-color: #fff;
      
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    .btn-wrapper {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 1rem;
      padding: 0 1rem;
      width: 100%;
    }
    .img-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(100vh - 196px);
      overflow: auto;
      padding: 3rem 0 1rem;
    }
    .barcode {
      display: flex;
      justify-content: center;
      margin: 1.5rem 0 0;
      max-width: 350px !important;
    }
    .bottom-text {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;
      background: #e9e9e9;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .pd20 { padding: 20px;}
    div.qr-code {
      width: 80%;
      height: 80%;
      margin: auto;
      padding: 20px;

    }

    div.qr-code > img {
      width: 80% !important;
    }

    .qr-reader-box {
        width:200px; height: 200px ;
    }

    .tc-lists2 {
      margin-top: 5px;
    }



</style>
